import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  AccountListParamsInterface,
  AccountCreateParamsInterface,
  PasswordModifyParamsInterface,
  AccountUnbindParamsInterface,
  AccountDeleteParamsInterface,
  ISendAirlockCode,
  IPostAirlockCode,
  IPostBookingCode,
  ISendBookingCode,
  ISendZhenguoCode,
  IPosetZhenguoCode,
  IEnroll,
  IGetThirdpartyList,
  ISyncerReservations,
  HttpResponseInterface,
  IBindAirbnb,
  IThirdpartyUnbindCount,
  ISyncerCalendars,
  ISendMeituanCode,
  IPostMeituanCode,
} from './http-interface';
import { Observable, tap } from 'rxjs';
import { Subject } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@root/shared/service/translate.service';
import { ErrorCode } from '@root/config';

const ACCOUNT_LIST_API = '/api/thirdparty/search';
const ACCOUNT_CREATE_API = '/api/thirdparty/create';
const ACCOUNT_UNBIND_API = '/api/thirdparty/unbind';
const PASSWORD_MODIFY_API = '/api/thirdparty/modify';
const ACCOUNT_DELETE_API = '/api/thirdparty/delete';
const THRIDPARTY_LOGIN_API = '/api/thirdparty/account_login';
const SYNC_HOUSE_API = '/api/thirdparty/alone_syncer';
const SYNCER_HOUSE_API = '/api/thirdparty/syncer_house';
const HAD_THIRDPARTY_API = '/api/thirdparty/had_thirdparty';
const SEND_AIRLOCK_CODE_API = '/api/thirdparty/get_airlock_code';
const POST_AIRLOCK_CODE_API = '/api/thirdparty/post_airlock_code';
const SEND_BOOKING_CODE_API = '/api/thirdparty/get_booking_code';
const POST_BOOKING_CODE_API = '/api/thirdparty/post_booking_code';
const SEND_ZHENGUO_CODE_API = '/api/thirdparty/get_zhenguo_code';
const POST_ZHENGUO_CODE_API = '/api/thirdparty/post_zhenguo_code';
const SEND_MEITUAN_CODE_API = '/api/thirdparty/get_meituan_code';
const POST_MEITUAN_CODE_API = '/api/thirdparty/post_meituan_code';
const RETRY_FAILED_TASKS_API = '/api/thirdparty/retry_refresh';
const ACCOUNT_LIST_V2_API = '/api/thirdparty/list';
const THIRDPARTY_UNBIND_COUNT_API = '/api/thirdparty/thirdparty_unbind_count';

const AIRBNB_ENROLL = '/api/thirdparty/airbnb_apply';
const AIRBNB_LINK_CHECK = '/api/thirdparty/airbnb_jump_check';

const GET_LOGIN_CAPTCHA = '/api/thirdparty/get_login_captcha';
const ACCOUNT_LIST_OF_ZHENGUO_API = '/api/thirdparty/account_list_of_zhenguo';

const GET_THIRDPARTY_LIST_API = '/api/thirdparty/list';
const SYNCER_RESERVATIONS_API = '/api/thirdparty/syncer_reservations';
const SYNCER_CALENDARS_API = '/api/thirdparty/syncer_calendars';

const AIRBNB_UNBIND_API = '/api/thirdparty/airbnb_unbind';
const AIRBNB_RECOMMEND_REPORT_API = '/api/thirdparty/airbnb_recommend_report';

export enum SyncState {
  Pending = 0,
  Complete = 1,
}

export type ModalType = 'create' | 're-login' | 'loading';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  syncStateChange$ = new Subject<SyncState>();
  accountSyncStateChange$ = new Subject<{
    state: SyncState;
    data: { ratio: string; account_id: number };
  }>();
  displayModal$ = new Subject<{ type: ModalType; data: any }>();

  constructor(private http: HttpClient, private modal: NzModalService, private t: TranslateService) {}

  //#region SYNC

  displayCreateAccountModal(data: { thirdpartyType: number }) {
    this.displayModal$.next({ type: 'create', data });
  }

  displayReLoginModal(data: { thirdpartyType: number; username: string; accountId: number }) {
    this.displayModal$.next({ type: 're-login', data });
  }

  displayLoginLoadingModal(data: { data: any; thirdpartyType: number }) {
    this.displayModal$.next({ type: 'loading', data });
  }

  syncStatePending() {
    this.syncStateChange$.next(SyncState.Pending);
  }

  syncStateComplete() {
    this.syncStateChange$.next(SyncState.Complete);
  }

  syncAccountStatePending(data) {
    this.accountSyncStateChange$.next({ state: SyncState.Pending, data });
  }

  syncAccountStateComplete(data) {
    this.accountSyncStateChange$.next({ state: SyncState.Complete, data });
  }

  syncAllHouses() {
    this.syncerAllHouse().subscribe((res) => {
      // if (res.error_code === 0) {
      //   const title = '线上房源读取中0%...';
      //   const desc = `发现0个房源`;
      //   const notify = new NotifyModel({
      //     type: Type.HOUSEORIGIN_ORDER,
      //     status: Status.DOING,
      //     // payload: data
      //     payload: {
      //       title,
      //       desc
      //     }
      //   });
      //   this.customMsgService.replace(Type.HOUSEORIGIN_ORDER, notify, {
      //     position: 'center'
      //   });
      // }
    });
  }

  //#endregion

  /**
   * 账号同步全部房源。
   */
  syncerAllHouse(): Observable<HttpResponseInterface> {
    return this.http.post(SYNCER_HOUSE_API, {}) as Observable<HttpResponseInterface>;
  }

  syncAccountHouse(params) {
    return this.http.post(SYNCER_HOUSE_API, params) as Observable<HttpResponseInterface>;
  }

  /**
   * 获取账号列表
   * @param params AccountListParamsInterface
   */
  getAccountList(params: AccountListParamsInterface): Observable<HttpResponseInterface> {
    let query = new HttpParams().append('page', `${params.page || 1}`).append('page_size', `${params.page_size || 20}`);
    if (params.thirdparty_type !== undefined) {
      query = query.append('thirdparty_type', `${params.thirdparty_type}`);
    }
    if (params.username !== undefined) {
      query = query.append('username', `${params.username}`);
    }
    return this.http.get(ACCOUNT_LIST_API, { params: query }) as Observable<HttpResponseInterface>;
  }

  getAccountListV2(params: AccountListParamsInterface) {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('thirdparty_type', `${params.thirdparty_type}`)
      .append('username', `${params.username}`);

    return this.http.get(ACCOUNT_LIST_V2_API, { params: query }) as Observable<HttpResponseInterface>;
  }

  /**
   * 创建账号
   * @param params AccountCreateParamsInterface
   */
  createAccount(params: AccountCreateParamsInterface): Observable<HttpResponseInterface> {
    return this.http.post(ACCOUNT_CREATE_API, params).pipe(
      tap((rst: any) => {
        if (rst.error_code === ErrorCode.AccountOccupied) {
          this.displayAccountOccupiedWarning(rst.data.token);
        }
      })
    ) as Observable<HttpResponseInterface>;
  }

  /** 登录第三方平台 */
  accountLogin(params: { id: string; verify_key?: string; verify_code?: string }) {
    return this.http.post(THRIDPARTY_LOGIN_API, params).pipe(
      tap((rst: any) => {
        if (rst.error_code === ErrorCode.AccountOccupied) {
          this.displayAccountOccupiedWarning(rst.data.token);
        }
      })
    ) as Observable<HttpResponseInterface>;
  }

  accountAuth(channel: string, params: any) {
    return this.http.post(`/api/thirdparty/auth/${channel}`, params).pipe(
      tap((rst: any) => {
        if (rst.error_code === ErrorCode.AccountOccupied) {
          this.displayAccountOccupiedWarning(rst.data.token);
        }
      })
    ) as Observable<HttpResponseInterface>;
  }

  /**
   * 修改密码
   * @param params PasswordModifyParamsInterface
   */
  modifyPassword(params: PasswordModifyParamsInterface): Observable<HttpResponseInterface> {
    return this.http.post(PASSWORD_MODIFY_API, params) as Observable<HttpResponseInterface>;
  }

  deleteAccount(params: AccountDeleteParamsInterface): Observable<HttpResponseInterface> {
    return this.http.post(ACCOUNT_DELETE_API, params) as Observable<HttpResponseInterface>;
  }

  /**
   * 账号解绑
   * @param params AccountUnbindParamsInterface
   */
  unbindAccount(params: AccountUnbindParamsInterface): Observable<HttpResponseInterface> {
    return this.http.post(ACCOUNT_UNBIND_API, params) as Observable<HttpResponseInterface>;
  }

  sendAirlockCode(params: ISendAirlockCode) {
    const query = new HttpParams()
      .append('id', `${params.id}`)
      .append('airlock_id', `${params.airlock_id}`)
      .append('verify_types', `${params.verify_types}`);
    return this.http.get(SEND_AIRLOCK_CODE_API, {
      params: query,
    }) as Observable<HttpResponseInterface>;
  }

  postAirlockCode(params: IPostAirlockCode) {
    return this.http.post(POST_AIRLOCK_CODE_API, params) as Observable<HttpResponseInterface>;
  }

  sendBookingCode(params: ISendBookingCode) {
    const query = new HttpParams()
      .append('id', `${params.id}`)
      .append('phone_id', `${params.phone_id}`)
      .append('verify_type', `${params.verify_type}`);
    return this.http.get(SEND_BOOKING_CODE_API, {
      params: query,
    }) as Observable<HttpResponseInterface>;
  }

  postBookingCode(params: IPostBookingCode) {
    return this.http.post(POST_BOOKING_CODE_API, params) as Observable<HttpResponseInterface>;
  }

  sendMeituanCode(params: ISendMeituanCode) {
    const query = new HttpParams()
      .append('id', `${params.id}`)
      .append('captcha_token', `${params.captcha_token}`)
      .append('captcha_code', `${params.captcha_code}`);
    return this.http.get(SEND_MEITUAN_CODE_API, {
      params: query,
    }) as Observable<HttpResponseInterface>;
  }

  postMeituanCode(params: IPostMeituanCode) {
    return this.http.post(POST_MEITUAN_CODE_API, params) as Observable<HttpResponseInterface>;
  }

  sendZhenguoCode(params: ISendZhenguoCode) {
    const query = new HttpParams()
      .append('id', `${params.id}`)
      .append('phone_id', `${params.phone_id}`)
      .append('verify_type', `${params.verify_type}`);
    return this.http.get(SEND_ZHENGUO_CODE_API, {
      params: query,
    }) as Observable<HttpResponseInterface>;
  }

  postZhenguoCode(params: IPosetZhenguoCode) {
    return this.http.post(POST_ZHENGUO_CODE_API, params) as Observable<HttpResponseInterface>;
  }

  /** 插件登录 */
  pluginLogin(account) {
    window.postMessage(
      JSON.stringify({
        receiver: 'god',
        action: 'login',
        thirdparty_type: 0,
        thirdparty_account_id: account,
      }),
      '/'
    );
  }

  /** 同步房源 */
  syncHouse(params: { id: number }) {
    return this.http.post(SYNC_HOUSE_API, params) as Observable<HttpResponseInterface>;
  }

  /** 重试同步失败的任务 */
  retryFailedTasks(params: { task_ids: string }) {
    return this.http.post(RETRY_FAILED_TASKS_API, params) as Observable<HttpResponseInterface>;
  }

  getCurrentAccountBindedThirdparties() {
    return this.http.get(HAD_THIRDPARTY_API) as Observable<HttpResponseInterface>;
  }
  airbnbEnroll(params: IEnroll) {
    return this.http.post(AIRBNB_ENROLL, params) as Observable<HttpResponseInterface>;
  }

  getThirdpartyUnbindHouseCount(params: IThirdpartyUnbindCount) {
    const query = new HttpParams().append('is_web', `${params.is_web}`);
    return this.http.get(THIRDPARTY_UNBIND_COUNT_API, {
      params: query,
    }) as Observable<HttpResponseInterface>;
  }
  airbnbLinkCheck(params: IEnroll) {
    return this.http.post(AIRBNB_LINK_CHECK, params) as Observable<HttpResponseInterface>;
  }

  getLoginCaptcha(params: { thirdparty_type: number }) {
    const query = new HttpParams().append('thirdparty_type', `${params.thirdparty_type}`);

    return this.http.get(GET_LOGIN_CAPTCHA, { params: query }) as Observable<HttpResponseInterface>;
  }

  /** 获取榛果渠道账号列表 */
  getAccountListOfZhenguo() {
    return this.http.get(ACCOUNT_LIST_OF_ZHENGUO_API) as Observable<HttpResponseInterface>;
  }

  /** 获取渠道账号列表 */
  getThirdpartyList(params: IGetThirdpartyList) {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('username', `${params.username}`)
      .append('thirdparty_type', `${params.thirdparty_type}`)
      .append('format', `${params.format}`);
    return this.http.get(GET_THIRDPARTY_LIST_API, {
      params: query,
    }) as Observable<HttpResponseInterface>;
  }

  /** 读取渠道订单情况 */
  syncerReservations(params: ISyncerReservations) {
    return this.http.post(SYNCER_RESERVATIONS_API, params) as Observable<HttpResponseInterface>;
  }

  syncerCalendars(params: ISyncerCalendars) {
    return this.http.post(SYNCER_CALENDARS_API, params) as Observable<HttpResponseInterface>;
  }

  /** 爱彼迎官方直连切换为账号直连 */
  airbnbOfficialToAccountLink(params: IBindAirbnb) {
    return this.http.post(AIRBNB_UNBIND_API, params) as Observable<HttpResponseInterface>;
  }

  /** 爱彼迎推荐账号记录 */
  airbnbRecommendReport(params: { username: string }) {
    return this.http.post(AIRBNB_RECOMMEND_REPORT_API, params) as Observable<HttpResponseInterface>;
  }

  displayAccountOccupiedWarning(token) {
    this.modal.confirm({
      nzTitle: this.t.t('channel_account-occupied-warning'),
      nzWidth: 545,
      nzOkText: this.t.t('word.yes'),
      nzOnOk: () => {
        this.requestDeleteSameAccount(token);
      },
    });
  }

  private requestDeleteSameAccount(token) {
    this.http.post('/api/thirdparty/delete_same', { token }).subscribe((rst) => {});
  }
}
